import { useEffect, useState } from 'react';
import { ErrorIcon } from '../../../Constants/Icons';

const Notifications = ({ type, duration = 5000, message, onClose }) => {
    const [progress, setProgress] = useState(100);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const enter = setTimeout(() => setVisible(true), 10);

        const start = Date.now();
        const closeTimer = setTimeout(() => setVisible(false), duration);
        const interval = setInterval(() => {
            const elapsed = Date.now() - start;
            setProgress(Math.max(0, 100 - (elapsed / duration) * 100));
        }, 50);

        return () => {
            clearTimeout(enter);
            clearTimeout(closeTimer);
            clearInterval(interval);
        };
    }, [duration, onClose]);

    const barRearColor = type === 'error' ? 'bg-[#fd5764]' : type === 'warning' ? 'bg-yellow-500' : 'bg-[#76da24]';

    const barFrontColor = type === 'error' ? 'bg-[#FECCD0]' : type === 'warning' ? 'bg-yellow-500' : 'bg-[#D5F3BD]';

    return (
        <div
            className={`fixed z-50 top-4 inset-x-0 mx-auto w-[90vw] max-w-[320px] sm:w-[80vw] sm:max-w-[360px] md:w-[60vw] md:max-w-[400px] lg:w-[50vw] lg:max-w-[480px] xl:w-[40vw] xl:max-w-[560px] 1.5xl:w-[35vw] 1.5xl:max-w-[640px] 2xl:w-[30vw] 2xl:max-w-[720px] 2.5xl:w-[25vw] 2.5xl:max-w-[800px] 3xl:w-[25vw] 3xl:max-w-[800px] bg-white rounded-lg shadow-md overflow-hidden flex flex-col transform transition-all duration-500 ease-out ${visible ? 'translate-y-0 opacity-100' : '-translate-y-12 opacity-0'}`}
            onTransitionEnd={() => {
                if (!visible) onClose();
            }}>

            <div className="w-full p-[20px] relative">
                <button
                    onClick={onClose}
                    className="font-[600] font-proximanova text-[28px] text-[#505050] hover:text-[#303030] hover:scale-110 transition duration-150 ease-in-out leading-none absolute top-[4px] right-[10px]"
                >
                    &times;
                </button>

                <div className="w-full flex flex-row items-center justify-center gap-[8px] sm:gap-[16px] lg:gap-[32px]">
                    {type === 'error' && <ErrorIcon />}
                    <p className="font-proximanova text-[16px] text-[#505050] text-center mb-0">{message}</p>
                </div>
            </div>

            <div className={`w-full h-[6px] ${barFrontColor} rounded-b-lg`}>
                <div
                    style={{
                        width: `${progress}%`,
                        transition: `width 50ms linear`,
                    }}
                    className={`h-full ${barRearColor}`}
                />
            </div>
        </div>
    );
}

export default Notifications;